import { render } from "./caseEditor.vue?vue&type=template&id=28b6b8e8"
import script from "./caseEditor.vue?vue&type=script&lang=js"
export * from "./caseEditor.vue?vue&type=script&lang=js"

import "./caseEditor.vue?vue&type=style&index=0&id=28b6b8e8&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__